import React, { useState, useContext } from "react"
import { useNavigate } from "react-router-dom"
import { Box, Typography, MenuItem, FormControl, ListItemText, Menu, Button, Grid } from "@mui/material"
import SchoolTwoToneIcon from "@mui/icons-material/SchoolTwoTone"
import UserContext from "../context/UserContext"
import { F_INDEX } from "../constants/routes"

const UserMenu = ({ showName, mainPage, bookmanagement, handleLogout, handleSupport }) => {
  const navigate = useNavigate()
  const { userData } = useContext(UserContext)

  const [openMenu, setOpenMenu] = useState(null)
  const open = Boolean(openMenu)

  const handleClose = () => {
    setOpenMenu(null)
  }
  const handleOpen = (event) => {
    setOpenMenu(event.currentTarget)
  }

  // return mainPage ? (
  //   <Box>
  //     <Box
  //       component={Button}
  //       display={{ xs: "none", md: "inline-flex" }}
  //       size="large"
  //       onClick={handleOpen}
  //       sx={{ float: "right", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
  //       endIcon={<SchoolTwoToneIcon />}>
  //       {userData?.Schulname || "Schulaccount"}
  //     </Box>

  //     <FormControl sx={{ visibility: "none" }}>
  //       <Menu
  //         id="user-menu"
  //         open={open}
  //         onClose={handleClose}
  //         anchorEl={openMenu}
  //         keepMounted
  //         MenuListProps={{
  //           "aria-labelledby": "basic-button",
  //         }}
  //         anchorOrigin={{
  //           vertical: "bottom",
  //           horizontal: "right",
  //         }}
  //         transformOrigin={{
  //           vertical: "top",
  //           horizontal: "right",
  //         }}>
  //         <MenuItem value="1" key="1">
  //           <ListItemText onClick={() => navigate(nav)}>Zur App</ListItemText>
  //         </MenuItem>
  //         <MenuItem value="2" key="2">
  //           <ListItemText onClick={handleLogout}>Log out</ListItemText>
  //         </MenuItem>
  //       </Menu>
  //     </FormControl>
  //   </Box>
  // ) : (

  return (
    <Box
      sx={{
        fontSize: "inherit",
        width: "80%",
        mx: "auto",
        visibility: showName ? "visible" : "hidden",
      }}>
      <Button
        variant="contained"
        fullWidth
        onClick={handleOpen}
        sx={{
          mt: "1vh",
          boxShadow: "none",
          height: "15vh",
          backgroundColor: bookmanagement ? "bmprimary.main" : "initial",
          "&:hover": {
            backgroundColor: bookmanagement ? "bmsecondary.main" : "initial",
          },
        }}>
        <Grid container>
          <Grid item xs={12}>
            <SchoolTwoToneIcon sx={{ color: "white", mx: "auto" }} />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1" sx={{ color: "white", textTransform: "none" }}>
              {userData?.user?.name || userData?.school?.name}
            </Typography>
          </Grid>
        </Grid>
      </Button>

      <FormControl sx={{ visibility: "none" }}>
        <Menu
          id="user-menu"
          open={open}
          onClose={handleClose}
          anchorEl={openMenu}
          keepMounted
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}>
          <MenuItem value="3" key="3">
            <ListItemText onClick={() => navigate(F_INDEX)}>Zur Startseite</ListItemText>
          </MenuItem>
          {!bookmanagement && (
            <MenuItem value="2" key="2">
              <ListItemText onClick={handleSupport}>Support</ListItemText>
            </MenuItem>
          )}
          <MenuItem value="2" key="2">
            <ListItemText onClick={handleLogout}>Log out</ListItemText>
          </MenuItem>
        </Menu>
      </FormControl>
    </Box>
  )
}
export default UserMenu
